import React, { useState } from 'react';
import {useSelector} from 'react-redux';
import {
    GridContainer,
    IconGridItem,
    ContentGridItem,
    HeaderMessage,
    BelowMessage,
    FlexContainer,
    MainMessage,
    SeparatorSpan,
    SurgeryNumberSpan,
} from './PageLevelMessage.styled.jsx';
import { sizes } from 'src/styles/Media.styled';
import { useTranslation } from 'react-i18next';
import { Grid } from '@material-ui/core';
import { GREEN_FONT_COLOR, DARK_RED_FONT_COLOR, PINK_HIGHLIGHT_COLOR } from 'src/styles/fonts/MCFontConstants';
import {isMobileDevice} from 'src/utils/util';
import { useEffectWithErrorLogging} from 'src/utils/useEffectWithErrorLogging';

const PageLevelMessage = (props) => {
    const {
        messageTextAlign,
        messagewhiteSpace,
        isCondensedView,
        imgHeight,
        imgWidth,
        marginTop,
        isFromReportUsage,
        message,
        surgeryNumber,
        mycaseNoColor,
        openOrderSummaryHandler,
        status,
        isFromConsignmentBilling=false,
        isFromReceiveSet=false,
        imgSrc,
        isFromReportIssue,
        imageContainerWidth,
        headerFontSize,
        messageFontSize,
        successMessage,
        boxShadow,
        isFromSurgery,
        isFromEquity=false,
        isFromSurgeryBomChanges = false
    } = props;
    const [background, setBackground] = useState('');
    //const [imgSrc, setImgSrc] = useState('');
    const { t } = useTranslation();
    const bannerHeight = useSelector((state) => state.loginReducer);

        const countryISOCode = useSelector(
        (state) => ({
            countryISOCode: state.loginReducer.hybrisUserDetails.countryISOCode
        })
    );

    useEffectWithErrorLogging(() => {
        if (status === 'success' || status === 'reportIssue') {
            setBackground(`${GREEN_FONT_COLOR} 0% 0% no-repeat padding-box`);
        } else if (status === 'warning') {
            setBackground('#F4AF3D 0% 0% no-repeat padding-box');
        } else if (status === 'failure') {
            setBackground(`${GREEN_FONT_COLOR} 0% 0% no-repeat padding-box`);
        } else if (status === 'error') {
            setBackground(`${DARK_RED_FONT_COLOR} 0% 0% no-repeat padding-box`);
        } else if (status === 'bomChange') {
            setBackground(
                isFromReportUsage
                    ? '#F7A800 0% 0% no-repeat padding-box'
                    : `${PINK_HIGHLIGHT_COLOR} 0% 0% no-repeat padding-box`
            );
            // setImgSrc(
            //     isFromReportUsage ? warningAssets : AlertCircleOutlineWhite
            // );
        }
    }, [isFromReportUsage, status]);

    const getMarginTop = () => {
        if (isMobileDevice()) {
            if (isFromEquity && !isCondensedView && bannerHeight?.bannerHeight) {
                return '4px';
            }
            if (bannerHeight?.bannerHeight && isCondensedView) {
                return '20px';
            }
            return marginTop || (!isCondensedView && isFromSurgery) ? '10px' : '40px';
        }
        return marginTop;
    };

    return (
        <GridContainer boxShadow={boxShadow}                                     isFromSurgeryBomChanges = {isFromSurgeryBomChanges}
 marginTop={getMarginTop()} isCondensedView={isCondensedView} isFromReportUsage = {isFromReportUsage} isFromSurgery={isFromSurgery}
 isFromConsignmentBilling={isFromConsignmentBilling}
 countryISOCode={countryISOCode}
 >
            <Grid container spacing={0} wrap="nowrap" alignItems="stretch">
                {/* First Grid Item - 20% width */}
                <Grid
                    item
                    xs={2.4} // 20% of 12 columns
                >
                    <IconGridItem background={background}  width={imageContainerWidth? imageContainerWidth:''}>
                        <img
                            src={imgSrc}
                            height={imgHeight}
                            width={imgWidth}
                            alt="message-icon"
                        />
                    </IconGridItem>
                </Grid>

                {/* Second Grid Item - 80% width */}
                <Grid
                    item
                    xs={9.6} // 80% of 12 columns
                >
                    <ContentGridItem status={status}>
                        {status === 'bomChange' || status === 'reportIssue' ? (
                            <>
                                <HeaderMessage
                                    isFromReportUsage={isFromReportUsage}
                                    headerFontSize={headerFontSize}
                                    textAlign={messageTextAlign}
                                    whiteSpace={messagewhiteSpace}
                                    status={status}
                                >
                                    {message}
                                </HeaderMessage>
                                <BelowMessage textAlign={messageTextAlign} messageFontSize={messageFontSize}>
                                    {isFromReportUsage
                                        ? t('consignmentBilling.common.UnknownLotSerialNumberMsg')
                                        : isFromReportIssue?
                                          successMessage
                                        : t('consignmentBilling.addSearchItems.msg')}
                                </BelowMessage>
                            </>
                        ) : status === 'error' ? (
                            <>
                                <HeaderMessage
                                    isFromReportUsage={isFromReportUsage}
                                    textAlign={messageTextAlign}
                                    whiteSpace={messagewhiteSpace}
                                    status={status}
                                >
                                    {message}
                                </HeaderMessage>
                            </>
                        ) : (
                            <FlexContainer isFromConsignmentBilling={isFromConsignmentBilling} isFromReceiveSet={isFromReceiveSet}>
                                <MainMessage
                                    textAlign={messageTextAlign}
                                    whiteSpace={messagewhiteSpace}
                                >
                                    {message}
                                </MainMessage>
                                {isCondensedView &&
                                    surgeryNumber &&
                                    !isFromConsignmentBilling &&
                                    window.innerWidth > sizes.mobileDevice && (
                                        <SeparatorSpan>|</SeparatorSpan>
                                    )}
                                {surgeryNumber && (
                                    <SurgeryNumberSpan
                                        id={`surgery-number-${surgeryNumber}`}
                                        onClick={openOrderSummaryHandler}
                                        color={mycaseNoColor}
                                        cursor={props.cursor}
                                    >
                                        {surgeryNumber}
                                    </SurgeryNumberSpan>
                                )}
                            </FlexContainer>
                        )}
                    </ContentGridItem>
                </Grid>
            </Grid>
        </GridContainer>
    );
};

export default PageLevelMessage;
